import SkapaCheckBox, {
  type CheckboxAttributes as SkapaCheckboxAttributes,
  type CheckboxProps as SkapaCheckboxProps,
} from "@ingka/checkbox";

export interface CheckboxProps
  extends SkapaCheckboxProps, SkapaCheckboxAttributes {}

export const Checkbox = (props: CheckboxProps) => {
  return <SkapaCheckBox prefix="saleslead__" {...props} />;
};
